import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import TypesOfRVsTemplate from '@/components/templates/TypesOfRVsTemplate';
import { getStaticPageData } from '@/services/getPageData';

export interface TypesOfRVsProps {
  heroHeading: string;
  title: string;
  description: string;
  seoUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contentBlocks: { type: string; value: any }[];
  noindex: boolean;
}

const TypesOfRVs: NextPage<TypesOfRVsProps> = props => {
  const { title, description, seoUrl, noindex } = props;

  return (
    <>
      <HeadMeta title={title} description={description} url={seoUrl} noindex={noindex} />
      <TypesOfRVsTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'types-of-rvs' });
  if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const { heading, seo_title, seo_description, url, content_blocks } = pageData.metadata;

  return {
    props: {
      heroHeading: heading,
      title: seo_title,
      description: seo_description,
      seoUrl: url,
      contentBlocks: content_blocks,
      noindex: !!pageData.fallback,
    },

    revalidate: 20,
  };
};

export default TypesOfRVs;
